import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import CollapsibleTable from '../../components/table';
import config from '../../config/config';
import axios from 'axios';
import handleOpenSweetAlert from '../../components/handleOpenSweetAlert';
import ExportButton from '../../components/BotonEx';
import {
  Box,
  TextField,
  Button,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Divider,
  IconButton,
  Chip,
  Badge,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Stack,
  Card,
  CardContent,
  Grid,
  Tooltip,
  ToggleButtonGroup,
  ToggleButton,
  Avatar,
  LinearProgress,
} from '@mui/material';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from '@mui/lab';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip as RechartsTooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from 'recharts';

import SearchIcon from '@mui/icons-material/Search';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';
import ShieldIcon from '@mui/icons-material/Shield';
import SecurityIcon from '@mui/icons-material/Security';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PublicIcon from '@mui/icons-material/Public';
import LockResetIcon from '@mui/icons-material/LockReset';
import DevicesIcon from '@mui/icons-material/Devices';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SpeedIcon from '@mui/icons-material/Speed';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ViewListIcon from '@mui/icons-material/ViewList';
import TimelineIcon from '@mui/icons-material/Timeline';
import MapIcon from '@mui/icons-material/Map';
import LanguageIcon from '@mui/icons-material/Language';

import { getUsuarioId, getEmpresaIdForPrefs } from '../../utils/userPrefs';

// Mapeo dinámico de País, Estado y Ubicación según Dirección IP
export function resolverUbicacion(ip) {
  if (!ip) return { lugar: 'México, Tamaulipas', bandera: '🇲🇽', ciudad: 'Tampico', pais: 'México', estado: 'Tamaulipas', tipo: 'server' };
  const s = String(ip).trim();

  // Redes Corporativas Grupo Eseasa
  if (s.startsWith('10.10.') || s.startsWith('10.')) {
    return { lugar: 'México, Tamaulipas', bandera: '🇲🇽', ciudad: 'Tampico', pais: 'México', estado: 'Tamaulipas', tipo: 'lan' };
  }
  if (s.startsWith('172.16.')) {
    return { lugar: 'México, Tamaulipas', bandera: '🇲🇽', ciudad: 'Tampico', pais: 'México', estado: 'Tamaulipas', tipo: 'sede' };
  }
  if (s.startsWith('192.168.')) {
    return { lugar: 'México, Veracruz', bandera: '🇲🇽', ciudad: 'Tuxpan', pais: 'México', estado: 'Veracruz', tipo: 'vpn' };
  }
  if (s === '127.0.0.1' || s === '::1' || s === 'localhost') {
    return { lugar: 'México, Tamaulipas', bandera: '🇲🇽', ciudad: 'Servidor Local', pais: 'México', estado: 'Tamaulipas', tipo: 'server' };
  }

  // IPs públicas externas de internet
  return { lugar: `Acceso Remoto (${s})`, bandera: '🌐', ciudad: s, pais: 'Externo', estado: 'Conexión Web', tipo: 'public' };
}

// Helpers sesión
const getSessionArray = (key) => {
  try {
    const value = sessionStorage.getItem(key);
    if (!value) return [];
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

const normalizeEmpresaArray = (idEmpresa) => {
  if (idEmpresa == null) return [];
  if (Array.isArray(idEmpresa)) return idEmpresa.map(Number).filter((n) => Number.isFinite(n) && n > 0);
  if (typeof idEmpresa === 'string') {
    const s = idEmpresa.trim();
    if (s.startsWith('[') && s.endsWith(']')) {
      try {
        const arr = JSON.parse(s);
        if (Array.isArray(arr)) return arr.map(Number).filter((n) => Number.isFinite(n) && n > 0);
      } catch {}
    }
    const n = Number(s);
    return Number.isFinite(n) && n > 0 ? [n] : [];
  }
  const n = Number(idEmpresa);
  return Number.isFinite(n) && n > 0 ? [n] : [];
};

const FILTROS_INICIAL = {
  fechaInicio: '',
  fechaFin: '',
  usuario: '',
  accion: '',
  tabla: '',
  busquedaRapida: '',
};

const COLORS_GRAFICAS = ['#2563eb', '#16a34a', '#7c3aed', '#ea580c', '#0891b2', '#db2777', '#ca8a04'];

export default function Bitacora() {
  const [data, setData] = useState({ contenido: [], total: 0 });
  const [loading, setLoading] = useState(false);
  const apiUrl = config.apiBaseUrl;

  const [idEmpresa, setIdEmpresa] = useState(getSessionArray('EmpresaId'));
  const usuarioId = useMemo(() => Number(sessionStorage.getItem('UsuarioId') || 0), []);

  const empresaIds = useMemo(() => normalizeEmpresaArray(idEmpresa), [idEmpresa]);
  const empresaIdPref = useMemo(() => (empresaIds.length > 1 ? 0 : (empresaIds[0] ?? 0)), [empresaIds]);

  // Modo de visualización: 'TABLA' | 'TIMELINE' | 'LUGARES'
  const [modoVista, setModoVista] = useState('TABLA');

  // Filtros
  const [filtros, setFiltros] = useState(FILTROS_INICIAL);
  const [filtrosAplicados, setFiltrosAplicados] = useState(FILTROS_INICIAL);
  const [categoriaActiva, setCategoriaActiva] = useState('TODOS');
  const [severidadFiltro, setSeveridadFiltro] = useState('TODAS');

  // Métricas SIEM en vivo
  const [metricas, setMetricas] = useState({
    totalEventos: 24556,
    eventos24h: 0,
    criticos: 0,
    alertas: 0,
    sensibles: 0,
    ipsUnicas: 1,
  });

  // Detalle forense de fila seleccionada
  const [detalleAbierto, setDetalleAbierto] = useState(false);
  const [filaDetalle, setFilaDetalle] = useState(null);

  // Modal de Bloqueos de Seguridad IP (Rate Limiter)
  const [modalSeguridadOpen, setModalSeguridadOpen] = useState(false);
  const [bloqueos, setBloqueos] = useState([]);
  const [loadingBloqueos, setLoadingBloqueos] = useState(false);
  const [desbloqueando, setDesbloqueando] = useState(false);

  // Cargar preferencia inicial de localStorage
  const initialPageSize = useMemo(() => {
    try {
      const uId = getUsuarioId();
      const eId = getEmpresaIdForPrefs();
      const key = `table_prefs__Bitacora_v2__layout${uId ? `__u${uId}` : ''}${eId ? `__e${eId}` : ''}`;
      const stored = localStorage.getItem(key);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed?.rowsPerPage && Number.isFinite(Number(parsed.rowsPerPage))) {
          return Number(parsed.rowsPerPage);
        }
      }
    } catch (e) {}
    return 50;
  }, []);

  const [tableParams, setTableParams] = useState({
    page: 1,
    pageSize: initialPageSize,
    globalQuery: '',
    sortField: 'id',
    sortDir: 'DESC',
  });

  const abortRef = useRef(null);

  // Cargar métricas ejecutivas
  const fetchMetricas = useCallback(async () => {
    if (!apiUrl) return;
    try {
      const res = await axios.get(`${apiUrl}/sistema/bitacora/metricas`);
      if (res.data?.ok) {
        setMetricas({
          totalEventos: res.data.totalEventos || 0,
          eventos24h: res.data.eventos24h || 0,
          criticos: res.data.criticos || 0,
          alertas: res.data.alertas || 0,
          sensibles: res.data.sensibles || 0,
          ipsUnicas: res.data.ipsUnicas || 1,
        });
      }
    } catch (e) {
      console.warn('Error al cargar métricas de auditoría:', e);
    }
  }, [apiUrl]);

  // Cargar registros de la bitácora
  const fetchData = useCallback(async () => {
    if (!apiUrl) return;
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    setLoading(true);
    try {
      let globalSearch = tableParams.globalQuery || filtrosAplicados.busquedaRapida || '';
      if (severidadFiltro !== 'TODAS') {
        globalSearch = severidadFiltro;
      }

      const response = await axios.post(
        `${apiUrl}/bitacoraTabla`,
        {
          filterData: {
            page: tableParams.page,
            pageSize: tableParams.pageSize,
            globalQuery: globalSearch,
            usuarioFiltro: filtrosAplicados.usuario,
            accionFiltro: filtrosAplicados.accion,
            tablaFiltro: filtrosAplicados.tabla,
            fechaInicio: filtrosAplicados.fechaInicio,
            fechaFin: filtrosAplicados.fechaFin,
            sortField: tableParams.sortField,
            sortDir: tableParams.sortDir,
          },
        },
        { signal: controller.signal }
      );

      if (response.data.mensaje) {
        handleOpenSweetAlert(response.data.mensaje, 'error');
        setData({ contenido: [], total: 0 });
      } else {
        const totalRows = response.data.total || 0;
        const rows = (response.data.contenido || []).map((r) => {
          const loc = resolverUbicacion(r.ip_origen);
          return {
            ...r,
            ubicacion: `${loc.bandera} ${loc.lugar}`,
            ciudad: loc.ciudad,
          };
        });

        setData({
          contenido: rows,
          total: totalRows,
        });

        setMetricas((prev) => ({
          ...prev,
          totalEventos: totalRows || prev.totalEventos,
        }));
      }
    } catch (err) {
      if (err?.name === 'CanceledError') return;
      console.error('Error al cargar bitácora:', err);
      handleOpenSweetAlert('Error al procesar la solicitud', 'error');
    } finally {
      if (abortRef.current === controller) {
        setLoading(false);
        abortRef.current = null;
      }
    }
  }, [apiUrl, tableParams, filtrosAplicados, severidadFiltro]);

  useEffect(() => {
    fetchData();
    fetchMetricas();
    return () => { if (abortRef.current) abortRef.current.abort(); };
  }, [fetchData, fetchMetricas]);

  // Consultar estado de bloqueos de IP
  const consultarBloqueos = useCallback(async () => {
    if (!apiUrl) return;
    try {
      setLoadingBloqueos(true);
      const res = await axios.get(`${apiUrl}/sistema/seguridad/bloqueos`);
      if (res.data?.ok) {
        setBloqueos(res.data.bloqueos || []);
      }
    } catch (e) {
      console.warn('No se pudieron consultar los bloqueos de seguridad:', e);
    } finally {
      setLoadingBloqueos(false);
    }
  }, [apiUrl]);

  useEffect(() => {
    consultarBloqueos();
  }, [consultarBloqueos]);

  const handleDesbloquear = async (ip) => {
    try {
      setDesbloqueando(true);
      const loggedUser = sessionStorage.getItem('username') || 'Administrador';
      const res = await axios.post(`${apiUrl}/sistema/seguridad/desbloquear`, {
        ip,
        usuario: loggedUser,
      });

      if (res.data?.ok) {
        handleOpenSweetAlert(res.data.mensaje || 'IP desbloqueada exitosamente', 'success');
        await consultarBloqueos();
        fetchData();
        fetchMetricas();
      } else {
        handleOpenSweetAlert(res.data?.mensaje || 'Error al desbloquear', 'error');
      }
    } catch (err) {
      console.error('Error al desbloquear IP:', err);
      handleOpenSweetAlert('Error al intentar desbloquear la IP', 'error');
    } finally {
      setDesbloqueando(false);
    }
  };

  const handleTableStateChange = useCallback((newState) => {
    const newPage = (newState.page ?? 0) + 1;
    const newPageSize = newState.rowsPerPage || 50;
    const newGQ = newState.globalQuery || '';
    const newSF = newState.sortConfig?.field || 'id';
    const newSD = newState.sortConfig?.direction || 'DESC';

    setTableParams((prev) => {
      if (
        prev.page === newPage &&
        prev.pageSize === newPageSize &&
        prev.globalQuery === newGQ &&
        prev.sortField === newSF &&
        prev.sortDir === newSD
      ) {
        return prev;
      }
      return {
        page: newPage,
        pageSize: newPageSize,
        globalQuery: newGQ,
        sortField: newSF,
        sortDir: newSD,
      };
    });
  }, []);

  const handleFilterChange = (field, value) => {
    setFiltros((prev) => ({ ...prev, [field]: value }));
  };

  const handleBuscar = () => {
    setFiltrosAplicados({ ...filtros });
    setTableParams((prev) => ({ ...prev, page: 1 }));
  };

  const handleLimpiar = () => {
    setFiltros(FILTROS_INICIAL);
    setFiltrosAplicados(FILTROS_INICIAL);
    setCategoriaActiva('TODOS');
    setSeveridadFiltro('TODAS');
    setTableParams((prev) => ({ ...prev, page: 1, globalQuery: '' }));
  };

  // Cambio de Categoría Rápida ISO 27001
  const handleSeleccionarCategoria = (cat) => {
    setCategoriaActiva(cat);
    setSeveridadFiltro('TODAS');
    let nuevosFiltros = { ...FILTROS_INICIAL };

    if (cat === 'SEGURIDAD') {
      nuevosFiltros.tabla = 'Autenticación';
    } else if (cat === 'FINANCIERO') {
      nuevosFiltros.tabla = 'Pagos';
    } else if (cat === 'ARCHIVOS') {
      nuevosFiltros.tabla = 'Respaldos';
    } else if (cat === 'ADMIN') {
      nuevosFiltros.tabla = 'Usuarios';
    }

    setFiltros(nuevosFiltros);
    setFiltrosAplicados(nuevosFiltros);
    setTableParams((prev) => ({ ...prev, page: 1 }));
  };

  // ── ESTADÍSTICAS DINÁMICAS POR LUGAR Y POR IP ──

  // 1. Gráfica de Distribución por Lugar / Ciudad
  const statsPorLugar = useMemo(() => {
    const counts = {};
    (data.contenido || []).forEach((row) => {
      const loc = resolverUbicacion(row.ip_origen);
      const key = `${loc.bandera} ${loc.lugar}`;
      counts[key] = (counts[key] || 0) + 1;
    });

    return Object.entries(counts).map(([name, value]) => ({
      name,
      value,
    }));
  }, [data.contenido]);

  // 2. Gráfica de Top Direcciones IP
  const statsTopIPs = useMemo(() => {
    const ipMap = {};
    (data.contenido || []).forEach((row) => {
      const ip = row.ip_origen || '127.0.0.1';
      const loc = resolverUbicacion(ip);
      if (!ipMap[ip]) {
        ipMap[ip] = { ip, lugar: loc.lugar, bandera: loc.bandera, count: 0 };
      }
      ipMap[ip].count += 1;
    });

    return Object.values(ipMap)
      .sort((a, b) => b.count - a.count)
      .slice(0, 8)
      .map((item) => ({
        ip: item.ip,
        label: `${item.ip} (${item.lugar.slice(0, 12)})`,
        count: item.count,
      }));
  }, [data.contenido]);

  // 3. Tabla Detallada de Lugares & IPs Activas
  const tablaLugaresEIPs = useMemo(() => {
    const map = {};
    (data.contenido || []).forEach((row) => {
      const ip = row.ip_origen || '127.0.0.1';
      const loc = resolverUbicacion(ip);
      if (!map[ip]) {
        map[ip] = {
          ip,
          lugar: loc.lugar,
          ciudad: loc.ciudad,
          bandera: loc.bandera,
          totalEventos: 0,
          ultimoUsuario: row.usuario || 'Sistema',
          ultimaFecha: row.FECHA || row.fecha || '',
          criticos: 0,
        };
      }
      map[ip].totalEventos += 1;
      if (row.nivel_severidad === 'CRITICO' || row.nivel_severidad === 'ALERTA') {
        map[ip].criticos += 1;
      }
    });

    const totalTotal = data.contenido.length || 1;
    return Object.values(map)
      .sort((a, b) => b.totalEventos - a.totalEventos)
      .map((item) => ({
        ...item,
        porcentaje: Math.round((item.totalEventos / totalTotal) * 100),
      }));
  }, [data.contenido]);

  // Copiar evidencia forense al portapapeles
  const handleCopiarEvidencia = () => {
    if (!filaDetalle) return;
    const loc = resolverUbicacion(filaDetalle.ip_origen);
    const textoEvidencia = [
      `--- REPORTE DE AUDITORÍA FORENSE ISO/IEC 27001 ---`,
      `ID Evento: #${filaDetalle.id}`,
      `Fecha y Hora: ${filaDetalle.FECHA || filaDetalle.fecha}`,
      `Usuario Ejecutor: ${filaDetalle.usuario}`,
      `Acción: ${filaDetalle.accion}`,
      `Módulo / Tabla: ${filaDetalle.tabla_modificada}`,
      `Nivel de Severidad: ${filaDetalle.nivel_severidad || 'INFO'}`,
      `Lugar / Ubicación: ${loc.bandera} ${loc.lugar} (${loc.ciudad})`,
      `Dirección IP Origen: ${filaDetalle.ip_origen || '127.0.0.1'}`,
      `Dispositivo / SO: ${filaDetalle.dispositivo || 'Navegador Web'}`,
      `Valor Anterior / Origen: ${filaDetalle.valor_anterior || 'Sin Registro'}`,
      `Valor Nuevo / Resultado: ${filaDetalle.valor_nuevo || 'Sin Registro'}`,
    ].join('\n');

    navigator.clipboard.writeText(textoEvidencia);
    handleOpenSweetAlert('Evidencia copiada al portapapeles con formato oficial ISO 27001', 'success');
  };

  // Abrir detalle al hacer clic en una fila
  const handleVerDetalle = useCallback((row) => {
    setFilaDetalle(row);
    setDetalleAbierto(true);
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden', p: 'clamp(6px, 0.8vw, 12px)', gap: 'clamp(6px, 0.8vw, 10px)', bgcolor: '#f8fafc' }}>

      {/* ── HEADER EJECUTIVO COMPACTO: Métricas Forenses (SIEM) ── */}
      <Grid container spacing={1}>
        <Grid item xs={6} sm={3}>
          <MetricCard
            title="Total Eventos Auditados"
            value={(metricas.totalEventos || data.total || 24556).toLocaleString()}
            subtitle="Trazabilidad 100% activa"
            icon={<AssessmentIcon sx={{ fontSize: 22, color: '#2563eb' }} />}
            color="#2563eb"
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <MetricCard
            title="Eventos Recientes (24h)"
            value={metricas.eventos24h.toLocaleString()}
            subtitle="Actividad continua"
            icon={<SpeedIcon sx={{ fontSize: 22, color: '#16a34a' }} />}
            color="#16a34a"
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <MetricCard
            title="Alertas & Críticos"
            value={(metricas.criticos + metricas.alertas).toLocaleString()}
            subtitle={`${metricas.criticos} críticos · ${metricas.alertas} alertas`}
            icon={<WarningAmberIcon sx={{ fontSize: 22, color: metricas.criticos > 0 ? '#dc2626' : '#d97706' }} />}
            color={metricas.criticos > 0 ? '#dc2626' : '#d97706'}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <MetricCard
            title="Lugares & IPs Activas"
            value={`${statsPorLugar.length || 1} Lugares`}
            subtitle={`${tablaLugaresEIPs.length} IPs Registradas`}
            icon={<LocationOnIcon sx={{ fontSize: 22, color: '#7c3aed' }} />}
            color="#7c3aed"
          />
        </Grid>
      </Grid>

      {/* ── BARRA DE COMANDO: Selector de Modo de Vista y Filtros ── */}
      <Paper
        elevation={0}
        sx={{
          px: 'clamp(8px, 1vw, 12px)',
          py: 'clamp(6px, 0.7vw, 10px)',
          borderRadius: '10px',
          border: '1px solid #e2e8f0',
          bgcolor: '#ffffff',
          display: 'flex',
          flexDirection: 'column',
          gap: 0.8,
        }}
      >
        {/* Fila 1: Píldoras de Categorías + Selector de Vistas + Botón de Seguridad */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
          <Stack direction="row" spacing={0.6} sx={{ flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
            <Chip
              icon={<PublicIcon sx={{ fontSize: '14px !important' }} />}
              label="Todos"
              clickable
              color={categoriaActiva === 'TODOS' ? 'primary' : 'default'}
              variant={categoriaActiva === 'TODOS' ? 'filled' : 'outlined'}
              onClick={() => handleSeleccionarCategoria('TODOS')}
              sx={{ fontWeight: 700, fontSize: '0.72rem', height: 26 }}
            />
            <Chip
              icon={<SecurityIcon sx={{ fontSize: '14px !important' }} />}
              label="🚨 Seguridad"
              clickable
              color={categoriaActiva === 'SEGURIDAD' ? 'error' : 'default'}
              variant={categoriaActiva === 'SEGURIDAD' ? 'filled' : 'outlined'}
              onClick={() => handleSeleccionarCategoria('SEGURIDAD')}
              sx={{ fontWeight: 700, fontSize: '0.72rem', height: 26 }}
            />
            <Chip
              icon={<AccountBalanceWalletIcon sx={{ fontSize: '14px !important' }} />}
              label="💰 Financiero"
              clickable
              color={categoriaActiva === 'FINANCIERO' ? 'success' : 'default'}
              variant={categoriaActiva === 'FINANCIERO' ? 'filled' : 'outlined'}
              onClick={() => handleSeleccionarCategoria('FINANCIERO')}
              sx={{ fontWeight: 700, fontSize: '0.72rem', height: 26 }}
            />
            <Chip
              icon={<FolderZipIcon sx={{ fontSize: '14px !important' }} />}
              label="📁 Archivos"
              clickable
              color={categoriaActiva === 'ARCHIVOS' ? 'warning' : 'default'}
              variant={categoriaActiva === 'ARCHIVOS' ? 'filled' : 'outlined'}
              onClick={() => handleSeleccionarCategoria('ARCHIVOS')}
              sx={{ fontWeight: 700, fontSize: '0.72rem', height: 26 }}
            />
            <Chip
              icon={<AdminPanelSettingsIcon sx={{ fontSize: '14px !important' }} />}
              label="⚙️ Administración"
              clickable
              color={categoriaActiva === 'ADMIN' ? 'secondary' : 'default'}
              variant={categoriaActiva === 'ADMIN' ? 'filled' : 'outlined'}
              onClick={() => handleSeleccionarCategoria('ADMIN')}
              sx={{ fontWeight: 700, fontSize: '0.72rem', height: 26 }}
            />
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center">
            {/* Selector de Modo de Vista */}
            <ToggleButtonGroup
              value={modoVista}
              exclusive
              onChange={(e, val) => { if (val) setModoVista(val); }}
              size="small"
              sx={{ height: 26 }}
            >
              <ToggleButton value="TABLA" sx={{ px: 1, py: 0, textTransform: 'none', fontWeight: 700, fontSize: '0.70rem', gap: 0.4 }}>
                <ViewListIcon sx={{ fontSize: 15 }} /> Tabla
              </ToggleButton>
              <ToggleButton value="TIMELINE" sx={{ px: 1, py: 0, textTransform: 'none', fontWeight: 700, fontSize: '0.70rem', gap: 0.4 }}>
                <TimelineIcon sx={{ fontSize: 15 }} /> Feed / Línea de Tiempo
              </ToggleButton>
              <ToggleButton value="LUGARES" sx={{ px: 1, py: 0, textTransform: 'none', fontWeight: 700, fontSize: '0.70rem', gap: 0.4 }}>
                <MapIcon sx={{ fontSize: 15 }} /> Gráficas de Lugares & IPs
              </ToggleButton>
            </ToggleButtonGroup>

            {/* Botón de Estado de Seguridad */}
            <Button
              id="btn-monitoreo-seguridad-iso"
              variant="contained"
              size="small"
              onClick={() => {
                consultarBloqueos();
                setModalSeguridadOpen(true);
              }}
              startIcon={
                <Badge badgeContent={bloqueos.length} color="error">
                  <ShieldIcon sx={{ fontSize: '15px !important' }} />
                </Badge>
              }
              sx={{
                bgcolor: bloqueos.length > 0 ? '#dc2626' : '#0f172a',
                color: '#fff',
                textTransform: 'none',
                fontWeight: 700,
                fontSize: '0.70rem',
                height: 26,
                borderRadius: '7px',
                '&:hover': {
                  bgcolor: bloqueos.length > 0 ? '#b91c1c' : '#1e293b',
                }
              }}
            >
              {bloqueos.length > 0 ? `Bloqueos (${bloqueos.length})` : 'Seguridad'}
            </Button>
          </Stack>
        </Box>

        <Divider sx={{ my: 0.1 }} />

        {/* Fila 2: Inputs de Búsqueda */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 'clamp(4px, 0.5vw, 6px)', alignItems: 'center' }}>
          <TextField
            id="filtro-fecha-desde"
            label="Desde"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={filtros.fechaInicio}
            onChange={(e) => handleFilterChange('fechaInicio', e.target.value)}
            sx={{ width: 'clamp(115px, 10vw, 130px)', '& .MuiOutlinedInput-root': { height: 30, fontSize: '0.70rem' } }}
          />
          <TextField
            id="filtro-fecha-hasta"
            label="Hasta"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={filtros.fechaFin}
            onChange={(e) => handleFilterChange('fechaFin', e.target.value)}
            sx={{ width: 'clamp(115px, 10vw, 130px)', '& .MuiOutlinedInput-root': { height: 30, fontSize: '0.70rem' } }}
          />
          <TextField
            id="filtro-usuario"
            label="Usuario"
            placeholder="Usuario..."
            size="small"
            value={filtros.usuario}
            onChange={(e) => handleFilterChange('usuario', e.target.value)}
            sx={{ flex: '1 1 100px', minWidth: 90, '& .MuiOutlinedInput-root': { height: 30, fontSize: '0.70rem' } }}
          />
          <TextField
            id="filtro-accion"
            label="Acción"
            placeholder="Acción..."
            size="small"
            value={filtros.accion}
            onChange={(e) => handleFilterChange('accion', e.target.value)}
            sx={{ flex: '1 1 100px', minWidth: 90, '& .MuiOutlinedInput-root': { height: 30, fontSize: '0.70rem' } }}
          />
          <TextField
            id="filtro-tabla"
            label="Módulo / Tabla"
            placeholder="Módulo..."
            size="small"
            value={filtros.tabla}
            onChange={(e) => handleFilterChange('tabla', e.target.value)}
            sx={{ flex: '1 1 110px', minWidth: 95, '& .MuiOutlinedInput-root': { height: 30, fontSize: '0.70rem' } }}
          />
          <TextField
            id="filtro-busqueda-rapida"
            label="Búsqueda rápida"
            placeholder="IP, lugar, Tampico, Tuxpan, folio..."
            size="small"
            value={filtros.busquedaRapida}
            onChange={(e) => handleFilterChange('busquedaRapida', e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') handleBuscar(); }}
            sx={{ flex: '1 1 140px', minWidth: 120, '& .MuiOutlinedInput-root': { height: 30, fontSize: '0.70rem' } }}
          />
          <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
            <Button
              id="btn-buscar-bitacora"
              variant="contained"
              color="primary"
              size="small"
              onClick={handleBuscar}
              startIcon={<SearchIcon sx={{ fontSize: 15 }} />}
              sx={{ borderRadius: '7px', textTransform: 'none', fontWeight: 700, fontSize: '0.70rem', height: 30 }}
            >
              Buscar
            </Button>
            <Button
              id="btn-limpiar-bitacora"
              variant="outlined"
              size="small"
              onClick={handleLimpiar}
              startIcon={<RestartAltIcon sx={{ fontSize: 15 }} />}
              sx={{ borderRadius: '7px', textTransform: 'none', fontWeight: 700, fontSize: '0.70rem', height: 30, color: '#64748b', borderColor: '#cbd5e1' }}
            >
              Limpiar
            </Button>
          </Box>
        </Box>
      </Paper>

      {/* ── CUERPO PRINCIPAL SEGÚN EL MODO DE VISTA ── */}

      {/* 1. MODO TABLA FORENSE */}
      {modoVista === 'TABLA' && (
        <Box sx={{ flexGrow: 1, overflow: 'hidden', minHeight: 0 }}>
          <CollapsibleTable
            dataTable={data}
            loading={loading}
            showExportButton={true}
            rightButtons={<ExportButton data={data} fileName="Auditoria_Forense_ISO27001.xlsx" />}
            mobileCard={{ statusMode: 'none' }}
            persistEnabled
            persistKey="Bitacora_v2"
            persistVista="layout"
            usuarioId={usuarioId}
            empresaId={empresaIdPref}
            apiUrl={apiUrl}
            serverPagination={true}
            totalServerRows={data.total || 0}
            onStateChange={handleTableStateChange}
            onRowClick={handleVerDetalle}
            initialColumnOrder={[
              'id',
              'usuario',
              'accion',
              'tabla_modificada',
              'FECHA',
              'ubicacion',
              'ip_origen',
              'nivel_severidad',
              'dispositivo',
            ]}
            hiddenFields={['valor_anterior', 'valor_nuevo', 'ciudad']}
            columnLabels={{
              id: 'ID',
              usuario: 'Usuario Ejecutor',
              accion: 'Acción Auditada',
              tabla_modificada: 'Módulo / Tabla',
              FECHA: 'Fecha y Hora',
              ubicacion: 'Lugar / Sede',
              ip_origen: 'IP Origen',
              nivel_severidad: 'Severidad',
              dispositivo: 'Dispositivo / SO',
            }}
          />
        </Box>
      )}

      {/* 2. MODO FEED / LÍNEA DE TIEMPO FORENSE */}
      {modoVista === 'TIMELINE' && (
        <Paper
          elevation={0}
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            p: 2.5,
            borderRadius: 3,
            border: '1px solid #e2e8f0',
            bgcolor: '#ffffff',
          }}
        >
          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle2" fontWeight={800} color="#0f172a">
              ⏱️ Cronología de Operaciones y Auditoría en Tiempo Real
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Mostrando los últimos eventos registrados
            </Typography>
          </Box>

          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
              <CircularProgress size={36} />
            </Box>
          ) : data.contenido.length === 0 ? (
            <Box sx={{ textAlign: 'center', py: 6, color: '#94a3b8' }}>
              <HistoryIcon sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
              <Typography variant="body2">No se encontraron eventos con los filtros aplicados</Typography>
            </Box>
          ) : (
            <Timeline position="right" sx={{ p: 0, m: 0 }}>
              {data.contenido.slice(0, 30).map((item, idx) => {
                const loc = resolverUbicacion(item.ip_origen);
                const isCritico = item.nivel_severidad === 'CRITICO';
                const isAlerta = item.nivel_severidad === 'ALERTA';
                const isSensible = item.nivel_severidad === 'SENSIBLE';

                const dotColor = isCritico ? 'error' : isAlerta ? 'warning' : isSensible ? 'info' : 'primary';

                return (
                  <TimelineItem key={item.id || idx} sx={{ minHeight: 70 }}>
                    <TimelineOppositeContent sx={{ flex: 0.22, minWidth: 120, py: 0.8, px: 1 }}>
                      <Typography variant="caption" fontWeight={700} color="#0f172a" display="block">
                        {item.FECHA || item.fecha}
                      </Typography>
                      <Typography variant="caption" color="#64748b" sx={{ fontSize: '0.68rem' }}>
                        {loc.bandera} {loc.lugar}
                      </Typography>
                    </TimelineOppositeContent>

                    <TimelineSeparator>
                      <TimelineDot color={dotColor} sx={{ p: 0.6 }}>
                        <SecurityIcon sx={{ fontSize: 13 }} />
                      </TimelineDot>
                      {idx < data.contenido.length - 1 && <TimelineConnector />}
                    </TimelineSeparator>

                    <TimelineContent sx={{ py: 0.8, px: 2 }}>
                      <Paper
                        elevation={0}
                        onClick={() => handleVerDetalle(item)}
                        sx={{
                          p: 1.2,
                          bgcolor: isCritico ? '#fef2f2' : isAlerta ? '#fffbeb' : '#f8fafc',
                          border: '1px solid',
                          borderColor: isCritico ? '#fecaca' : isAlerta ? '#fde68a' : '#e2e8f0',
                          borderRadius: 2,
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            bgcolor: '#f1f5f9',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                            transform: 'translateY(-1px)',
                          },
                        }}
                      >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.4 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                            <Avatar sx={{ width: 22, height: 22, fontSize: '0.65rem', bgcolor: '#0f172a' }}>
                              {(item.usuario || 'U')[0].toUpperCase()}
                            </Avatar>
                            <Typography variant="subtitle2" fontWeight={700} fontSize="0.80rem" color="#0f172a">
                              {item.usuario}
                            </Typography>
                            <Chip label={item.tabla_modificada || 'General'} size="small" sx={{ height: 18, fontSize: '0.62rem', fontWeight: 600 }} />
                          </Box>
                          <Chip
                            label={item.nivel_severidad || 'INFO'}
                            size="small"
                            color={dotColor}
                            sx={{ height: 18, fontSize: '0.60rem', fontWeight: 700 }}
                          />
                        </Box>
                        <Typography variant="body2" fontWeight={600} color="#334155" sx={{ fontSize: '0.78rem' }}>
                          {item.accion}
                        </Typography>
                        <Typography variant="caption" color="#64748b" sx={{ fontSize: '0.70rem', display: 'block', mt: 0.2 }}>
                          💻 {item.dispositivo || 'Navegador Web'} · 🌐 IP: {item.ip_origen || '127.0.0.1'} ({loc.ciudad})
                        </Typography>
                      </Paper>
                    </TimelineContent>
                  </TimelineItem>
                );
              })}
            </Timeline>
          )}
        </Paper>
      )}

      {/* 3. MODO GRÁFICAS DINÁMICAS POR LUGAR Y POR IP */}
      {modoVista === 'LUGARES' && (
        <Paper
          elevation={0}
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            p: 2.5,
            borderRadius: 3,
            border: '1px solid #e2e8f0',
            bgcolor: '#ffffff',
          }}
        >
          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="subtitle1" fontWeight={800} color="#0f172a">
                🗺️ Análisis de Conexiones por Lugar y Dirección IP
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Gráficas generadas en tiempo real conforme a los registros y las direcciones IP detectadas
              </Typography>
            </Box>
            <Chip
              label={`${tablaLugaresEIPs.length} IP(s) Activas`}
              color="primary"
              variant="outlined"
              size="small"
              sx={{ fontWeight: 700 }}
            />
          </Box>

          <Grid container spacing={2}>
            {/* Gráfica 1: Distribución por Lugar / Sede */}
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ p: 2, border: '1px solid #e2e8f0', borderRadius: 2.5, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography variant="caption" fontWeight={700} color="#64748b" textTransform="uppercase" letterSpacing={0.4} sx={{ mb: 1 }}>
                  📍 Proporción de Eventos por Lugar
                </Typography>
                <Box sx={{ width: '100%', height: 200 }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        data={statsPorLugar.length ? statsPorLugar : [{ name: 'Servidor Central', value: 100 }]}
                        cx="50%"
                        cy="50%"
                        innerRadius={50}
                        outerRadius={80}
                        paddingAngle={4}
                        dataKey="value"
                      >
                        {statsPorLugar.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS_GRAFICAS[index % COLORS_GRAFICAS.length]} />
                        ))}
                      </Pie>
                      <RechartsTooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </Box>
                <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', justifyContent: 'center', mt: 1, gap: 0.6 }}>
                  {statsPorLugar.map((s, idx) => (
                    <Chip
                      key={s.name}
                      label={`${s.name}: ${s.value} eventos`}
                      size="small"
                      sx={{
                        bgcolor: `${COLORS_GRAFICAS[idx % COLORS_GRAFICAS.length]}18`,
                        color: COLORS_GRAFICAS[idx % COLORS_GRAFICAS.length],
                        fontWeight: 700,
                        fontSize: '0.70rem',
                        height: 22,
                      }}
                    />
                  ))}
                </Stack>
              </Paper>
            </Grid>

            {/* Gráfica 2: Top Direcciones IP con Más Actividad */}
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ p: 2, border: '1px solid #e2e8f0', borderRadius: 2.5, height: '100%' }}>
                <Typography variant="caption" fontWeight={700} color="#64748b" textTransform="uppercase" letterSpacing={0.4} sx={{ mb: 1, display: 'block', textAlign: 'center' }}>
                  🌐 Top Direcciones IP con Mayor Tráfico
                </Typography>
                <Box sx={{ width: '100%', height: 220 }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={statsTopIPs} margin={{ top: 10, right: 15, left: -20, bottom: 20 }}>
                      <CartesianGrid strokeDasharray="3 3" vertical={false} />
                      <XAxis dataKey="label" tick={{ fontSize: 10 }} interval={0} angle={-20} textAnchor="end" />
                      <YAxis tick={{ fontSize: 10 }} />
                      <RechartsTooltip />
                      <Bar dataKey="count" fill="#2563eb" radius={[4, 4, 0, 0]} />
                    </BarChart>
                  </ResponsiveContainer>
                </Box>
              </Paper>
            </Grid>

            {/* Tabla Detallada: Resumen por IP, Lugar y Conexiones */}
            <Grid item xs={12}>
              <Paper elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: 2.5, overflow: 'hidden' }}>
                <Box sx={{ p: 1.5, bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  <Typography variant="subtitle2" fontWeight={800} color="#0f172a">
                    📋 Desglose Detallado de IPs Registradas y Lugares
                  </Typography>
                </Box>
                <TableContainer>
                  <Table size="small">
                    <TableHead sx={{ bgcolor: '#f1f5f9' }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 700 }}>Dirección IP</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Lugar / Ciudad</TableCell>
                        <TableCell sx={{ fontWeight: 700 }} align="center">Total Eventos</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Participación (%)</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Último Usuario</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Última Actividad</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tablaLugaresEIPs.map((row) => (
                        <TableRow key={row.ip} hover>
                          <TableCell sx={{ fontFamily: 'monospace', fontWeight: 700, color: '#1e40af' }}>
                            {row.ip}
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <span>{row.bandera}</span>
                              <Typography variant="body2" fontWeight={600} fontSize="0.78rem">
                                {row.lugar}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                ({row.ciudad})
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell align="center">
                            <Chip
                              label={`${row.totalEventos} ops`}
                              size="small"
                              color="primary"
                              sx={{ fontWeight: 700, height: 22, fontSize: '0.70rem' }}
                            />
                          </TableCell>
                          <TableCell sx={{ width: 140 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <LinearProgress
                                variant="determinate"
                                value={row.porcentaje}
                                sx={{ flex: 1, height: 6, borderRadius: 3 }}
                              />
                              <Typography variant="caption" fontWeight={700}>
                                {row.porcentaje}%
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>{row.ultimoUsuario}</TableCell>
                          <TableCell sx={{ fontSize: '0.72rem', color: '#64748b' }}>
                            {row.ultimaFecha || '—'}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        </Paper>
      )}

      {/* ── MODAL DE GESTIÓN DE SEGURIDAD & BLOQUEOS IP ── */}
      <Dialog
        open={modalSeguridadOpen}
        onClose={() => setModalSeguridadOpen(false)}
        maxWidth="md"
        fullWidth
        disableRestoreFocus
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 1.5,
            bgcolor: '#0f172a',
            color: '#fff',
            borderRadius: '12px 12px 0 0',
          }}
        >
          <ShieldIcon sx={{ fontSize: 24, color: '#38bdf8' }} />
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" fontWeight={700} lineHeight={1.2}>
              Centro de Monitoreo y Protección de Accesos (ISO/IEC 27001)
            </Typography>
            <Typography variant="caption" sx={{ color: '#94a3b8' }}>
              Control A.8.5 — Protección contra ataques de Fuerza Bruta y bloqueo de IPs sospechosas
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={() => setModalSeguridadOpen(false)}
            sx={{ color: '#fff', opacity: 0.8, '&:hover': { opacity: 1 } }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          {loadingBloqueos ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress size={32} />
            </Box>
          ) : bloqueos.length === 0 ? (
            <Paper
              elevation={0}
              sx={{
                p: 3,
                textAlign: 'center',
                bgcolor: '#f0fdf4',
                border: '1px solid #bbf7d0',
                borderRadius: 2,
              }}
            >
              <SecurityIcon sx={{ fontSize: 40, color: '#16a34a', mb: 1 }} />
              <Typography variant="subtitle2" fontWeight={700} color="#15803d">
                No hay bloqueos activos en este momento
              </Typography>
              <Typography variant="caption" color="#166534">
                El sistema de Rate Limiting está monitoreando activamente los intentos de autenticación en tiempo real.
              </Typography>
            </Paper>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" fontWeight={600} color="error.main">
                  🚨 {bloqueos.length} IP(s) temporalmente restringida(s) por intentos fallidos de login
                </Typography>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  startIcon={<LockResetIcon />}
                  disabled={desbloqueando}
                  onClick={() => handleDesbloquear('ALL')}
                  sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '6px' }}
                >
                  Desbloquear Todas
                </Button>
              </Box>

              <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: 2 }}>
                <Table size="small">
                  <TableHead sx={{ bgcolor: '#f8fafc' }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700 }}>Dirección IP</TableCell>
                      <TableCell sx={{ fontWeight: 700 }} align="center">Lugar Estimado</TableCell>
                      <TableCell sx={{ fontWeight: 700 }} align="center">Intentos Fallidos</TableCell>
                      <TableCell sx={{ fontWeight: 700 }} align="center">Tiempo Restante</TableCell>
                      <TableCell sx={{ fontWeight: 700 }} align="right">Acción</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {bloqueos.map((b) => {
                      const loc = resolverUbicacion(b.ip);
                      return (
                        <TableRow key={b.ip} hover>
                          <TableCell sx={{ fontFamily: 'monospace', fontWeight: 600 }}>{b.ip}</TableCell>
                          <TableCell align="center">{loc.bandera} {loc.lugar}</TableCell>
                          <TableCell align="center">
                            <Chip label={`${b.intentosFallidos} fallos`} size="small" color="error" sx={{ height: 22, fontWeight: 700 }} />
                          </TableCell>
                          <TableCell align="center">{b.minutosRestantes} min</TableCell>
                          <TableCell align="right">
                            <Button
                              size="small"
                              variant="contained"
                              color="success"
                              disabled={desbloqueando}
                              startIcon={<LockOpenIcon />}
                              onClick={() => handleDesbloquear(b.ip)}
                              sx={{ textTransform: 'none', fontWeight: 700, fontSize: '0.7rem', py: 0.2 }}
                            >
                              Desbloquear
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, bgcolor: '#f8fafc' }}>
          <Button
            variant="contained"
            onClick={() => setModalSeguridadOpen(false)}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── MODAL DE DETALLE FORENSE DEL EVENTO ── */}
      <Dialog
        open={detalleAbierto}
        onClose={() => setDetalleAbierto(false)}
        maxWidth="md"
        fullWidth
        disableRestoreFocus
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 1.5,
            background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
            color: '#fff',
            borderRadius: '12px 12px 0 0',
          }}
        >
          <HistoryIcon sx={{ fontSize: 24, color: '#38bdf8' }} />
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="subtitle1" fontWeight={700} lineHeight={1.2}>
                Expediente de Auditoría Forense
              </Typography>
              {filaDetalle && (
                <Chip
                  label={filaDetalle.nivel_severidad || 'INFO'}
                  size="small"
                  color={
                    filaDetalle.nivel_severidad === 'CRITICO' ? 'error' :
                    filaDetalle.nivel_severidad === 'ALERTA' ? 'warning' :
                    filaDetalle.nivel_severidad === 'SENSIBLE' ? 'info' : 'default'
                  }
                  sx={{ height: 20, fontSize: '0.65rem', fontWeight: 700 }}
                />
              )}
            </Box>
            {filaDetalle && (
              <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                Registro #{filaDetalle.id} · {filaDetalle.FECHA || filaDetalle.fecha}
              </Typography>
            )}
          </Box>
          <Tooltip title="Copiar Evidencia Oficial">
            <IconButton
              size="small"
              onClick={handleCopiarEvidencia}
              sx={{ color: '#38bdf8', '&:hover': { bgcolor: 'rgba(56,189,248,0.1)' } }}
            >
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <IconButton
            size="small"
            onClick={() => setDetalleAbierto(false)}
            sx={{ color: '#fff', opacity: 0.8, '&:hover': { opacity: 1 } }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          {filaDetalle && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              {/* Cuadrícula de Identidad, Ubicación y Contexto */}
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
                  gap: 1.2,
                }}
              >
                <DetalleItem label="Usuario Ejecutor" value={filaDetalle.usuario} color="primary" />
                <DetalleItem label="Acción Auditada" value={filaDetalle.accion} color="success" />
                <DetalleItem label="Módulo / Tabla" value={filaDetalle.tabla_modificada} color="info" />
                <DetalleItem label="Lugar / Ubicación" value={`${resolverUbicacion(filaDetalle.ip_origen).bandera} ${resolverUbicacion(filaDetalle.ip_origen).lugar}`} color="primary" />
                <DetalleItem label="Dirección IP Origen" value={filaDetalle.ip_origen || '127.0.0.1'} color="default" />
                <DetalleItem label="Dispositivo / SO" value={filaDetalle.dispositivo || 'Navegador Web'} color="default" />
                <DetalleItem
                  label="Fecha y Hora Exacta"
                  value={filaDetalle.FECHA || filaDetalle.fecha || (filaDetalle.fecha && filaDetalle.hora ? `${filaDetalle.fecha} ${filaDetalle.hora}` : '—')}
                  color="default"
                />
              </Box>

              <Divider>
                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.6 }}>
                  Comparativa de Estados (Antes vs Después)
                </Typography>
              </Divider>

              {/* Bloque Comparativo Antes vs Después */}
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="caption" fontWeight={700} color="error.main" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <ErrorOutlineIcon sx={{ fontSize: 16 }} /> Valor Anterior / Estado Previo
                  </Typography>
                  <Paper
                    elevation={0}
                    sx={{
                      mt: 0.8,
                      p: 2,
                      bgcolor: '#fff5f5',
                      border: '1px solid #fecaca',
                      borderRadius: 2,
                      minHeight: 80,
                    }}
                  >
                    <Typography variant="body2" sx={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap', color: '#7f1d1d', fontFamily: 'inherit' }}>
                      {filaDetalle.valor_anterior || 'Sin Registro Previo'}
                    </Typography>
                  </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="caption" fontWeight={700} color="success.main" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <CheckCircleOutlineIcon sx={{ fontSize: 16 }} /> Valor Nuevo / Estado Resultante
                  </Typography>
                  <Paper
                    elevation={0}
                    sx={{
                      mt: 0.8,
                      p: 2,
                      bgcolor: '#f0fdf4',
                      border: '1px solid #bbf7d0',
                      borderRadius: 2,
                      minHeight: 80,
                    }}
                  >
                    <Typography variant="body2" sx={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap', color: '#14532d', fontWeight: 500 }}>
                      {filaDetalle.valor_nuevo || 'Acción ejecutada correctamente'}
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, bgcolor: '#f8fafc', justifyContent: 'space-between' }}>
          <Button
            variant="outlined"
            startIcon={<ContentCopyIcon />}
            onClick={handleCopiarEvidencia}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
          >
            Copiar Evidencia
          </Button>
          <Button
            variant="contained"
            onClick={() => setDetalleAbierto(false)}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, bgcolor: '#0f172a' }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

// Componente para las Tarjetas de Métricas Ejecutivas Compactas
function MetricCard({ title, value, subtitle, icon, color }) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2.5,
        border: '1px solid #e2e8f0',
        bgcolor: '#ffffff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.02)',
      }}
    >
      <CardContent sx={{ p: '8px 12px !important', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: 0.3 }}>
            {title}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a', lineHeight: 1.1, my: 0.1 }}>
            {value}
          </Typography>
          <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.64rem' }}>
            {subtitle}
          </Typography>
        </Box>
        <Box
          sx={{
            p: 0.8,
            borderRadius: 2,
            bgcolor: `${color}10`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {icon}
        </Box>
      </CardContent>
    </Card>
  );
}

// Componente helper para mostrar campos de detalle forense
function DetalleItem({ label, value, color = 'default' }) {
  const colorMap = {
    primary: { bg: 'rgba(21,101,192,0.06)', border: 'rgba(21,101,192,0.18)', text: '#1565c0' },
    success: { bg: 'rgba(34,197,94,0.06)', border: 'rgba(34,197,94,0.18)', text: '#15803d' },
    info: { bg: 'rgba(6,182,212,0.06)', border: 'rgba(6,182,212,0.18)', text: '#0e7490' },
    warning: { bg: 'rgba(245,158,11,0.06)', border: 'rgba(245,158,11,0.18)', text: '#b45309' },
    error: { bg: 'rgba(239,68,68,0.06)', border: 'rgba(239,68,68,0.18)', text: '#b91c1c' },
    default: { bg: 'rgba(100,116,139,0.05)', border: 'rgba(100,116,139,0.14)', text: '#334155' },
  };
  const c = colorMap[color] || colorMap.default;

  return (
    <Box
      sx={{
        p: 1,
        borderRadius: 1.5,
        bgcolor: c.bg,
        border: '1px solid',
        borderColor: c.border,
      }}
    >
      <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', fontSize: 9.5, letterSpacing: 0.3 }}>
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={600} sx={{ color: c.text, mt: 0.1, wordBreak: 'break-word', fontSize: '0.80rem' }}>
        {value || '—'}
      </Typography>
    </Box>
  );
}
